export interface ImageStyle {
  code: string;
  name: string;
  description: string;
  illustrationUrl?: string;
}

export const IMAGE_STYLES: ImageStyle[] = [
  {
    code: 'ANIME_MODERN',
    name: 'Modern Anime',
    description: 'High-quality modern anime style, clean lines, vibrant colors, expressive characters, detailed backgrounds, Makoto Shinkai or CoMix Wave Films vibe.',
    illustrationUrl: 'https://images.unsplash.com/photo-1578632738908-4521c726eebf?q=80&w=500&auto=format&fit=crop'
  },
  {
    code: 'CINEMATIC_REALISTIC',
    name: 'Cinematic Realistic',
    description: 'Highly detailed cinematic realism, 8k resolution, realistic lighting, volumetric fog, dramatic shadows, shallow depth of field, professional movie shot.',
    illustrationUrl: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?q=80&w=500&auto=format&fit=crop'
  },
  {
    code: 'COMIC_AMERICAN',
    name: 'American Comic',
    description: 'Classic American comic book style, bold ink lines, Ben-Day dots, high contrast, dynamic action poses, Marvel or DC comics aesthetic.',
    illustrationUrl: 'https://images.unsplash.com/photo-1588497859490-85d1c17db96d?q=80&w=500&auto=format&fit=crop'
  },
  {
    code: 'WATERCOLOR_ART',
    name: 'Watercolor Art',
    description: 'Soft watercolor painting style, fluid textures, pastel colors, artistic brush strokes, dreamlike and ethereal atmosphere.',
    illustrationUrl: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?q=80&w=500&auto=format&fit=crop'
  },
  {
    code: '3D_RENDER_PIXAR',
    name: '3D Pixar Style',
    description: 'Stylized 3D render, soft round shapes, expressive facial features, vibrant lighting, clean textures, Pixar or Disney animation style.',
    illustrationUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?q=80&w=500&auto=format&fit=crop'
  }
];
